<template>
  <div class="index-documenti" :style="{ height: (contenitoreHeight) + 'px'}">
    <!--<header-app :counterNuovi="counterNuovi"></header-app>-->
    <div>
      <div class="titolo-app col-lg-14 col-md-11 col-sm-6 col-1 no-padding">
          <span class="titolo-bold hidden-xs">
            {{ getLabel(menuApps.label) }}
          </span>
      </div>

      <div class="contenitore col-24 no-padding"
           :style="{ height: (contenitoreHeight - 40) + 'px'}">
        <!-- <menu-app></menu-app> -->
        <div class="row row-custom">
          
          <el-tabs v-model="tabActive" type="card" class="col-24 document-menu" v-loading="loading">
            <el-tab-pane v-for="(app, index) in apps" :key="index" :name="app.codice" >
              
              <div slot="label" @click="link(app)" >
                <div class="col-24 no-padding barra"></div>
                <el-badge :value="getCounter(app)" class="item" :hidden="getCounter(app) === 0">
                  <div class="app-name" >
                    <span>{{ getLabel(app.label[0]) }}</span>
                  </div>
                </el-badge>
              </div>
            </el-tab-pane>

            <!--<router-view class="box-documenti col-24" :style="{ height: (contenitoreHeight - 40 - 60 -30) + 'px'}"
                       :contenitoreHeight="contenitoreHeight - 60 - 60" :key="$route.name"></router-view>-->

            <comunicazioni v-if="objComunicazione.tipologia == 'COM'" class="box-documenti col-24" :style="{ height: (contenitoreHeight - 40 - 60 -30) + 'px'}"
                       :contenitoreHeight="contenitoreHeight - 60 - 60" :key="objComunicazione.codice" :objComunicazione="objComunicazione"></comunicazioni>
            <modulistica v-if="objComunicazione.tipologia == 'MOD'" class="box-documenti col-24" :style="{ height: (contenitoreHeight - 40 - 60 -30) + 'px'}"
                       :contenitoreHeight="contenitoreHeight - 60 - 60" :key="objComunicazione.codice" :objComunicazione="objComunicazione"></modulistica>
          </el-tabs>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
  import {bus} from '../Bus.js'
  import Comunicazioni from './Comunicazioni.vue'
  import Modulistica from './Modulistica.vue'

  export default {
    components: {
        Comunicazioni,
        Modulistica
    },
    props: {
      area: {
        type: String,
        default: 'documenti'
      },
      contenitoreHeight: {
        type: Number
      }
    },
    name: 'IndexDocumenti',
    data () {
      return {
        tabActive: '-1',
        loading: false,
        showScroll: true,
        menuApps: {},
        menu: {},
        apps: [],
        areaProva: this.area,
        tadSelected: -1,
        objComunicazione: {},
        codLang: ''
      }
    },
    watch: {
      '$store.state.menu.codiApp': function (to, from) {
        if (!this._inactive) {
          this.initialize()
        }
      }
    },
    mounted: function () {
      bus.$on('changeLanguage', () => {
        this.codLang = sessionStorage.getItem('codLang')
      })

    },
    activated: function () {
      this.initialize()
    },
    deactivated: function () {
    },
    methods: {
      initialize: function () {
        this.codLang = sessionStorage.getItem('codLang')
        this.$set(this, 'menuApps', this.$store.state.menu)
        this.$set(this, 'objComunicazione', {})
        this.getMenu()
      },
      getMenu: function () {
        this.loading = true
         var obj = {
          params: {
            codiApp: this.menuApps.codiApp
          }
        }
        this.$http.get('dipendente/' + this.$store.state.country + '/docMenu', obj).then(response => {
          this.$set(this, 'apps', response.body.data)
          //sessionStorage.setItem('menu', JSON.stringify(response.body.data))
          this.loading = false
        })
      },
      link: function (app,index) {
        //this.$router.push({name: route})
        this.$set(this, 'tadSelected', index)
        this.$set(this, 'objComunicazione', app)
      },
      docStyle: function (docType) {
        let name = this.$route.name
        return docType === name ? true : false
      },
      getCounter: function (docType) {
        let messaggiCount = this.$store.state.messaggiCount
        return messaggiCount[docType.codiCom]
      },
      getLabel: function (label) {
        if (label === undefined || label === null) {
          return "ERROR"
        } else {
          return label[this.codLang]
        }
      }
    }
  }
</script>

<style lang="less">
  @import "../../assets/less/general.less";

  .contenitore-documenti {
    margin-top: 10px !important;
  }

  .document-menu {
    margin-top: 30px;

    .el-tabs__header {
      margin-bottom: 0px;

      .el-tabs__nav {
        //background-color: #f2f2f2;
        height: 48px;
        border: none;
        .el-tabs__item {
          min-width: 120px;
          padding: 0px;
          border: none;
          .barra {
            height: 5px;
            background-color: #fff;
          }
          .el-badge {
            width: 100%;
            .app-name {
              width: 100%;
              border: 1px solid #ECEBEB;
              background-color: #F9F9F9;
              span {
                text-transform: uppercase;
                .set-font(@family: 'os-semibold', @size: 13px, @color: @grayTesto);
                width: 100%;
                display: block;
                padding-left: 20px;
                padding-right: 20px;
              }
            }
            .el-badge__content{
              top: 10px;
              right: 22px;
              background-color: #bb515c;
              border-radius: 10px;
              color: #FFF;
              font-size: 12px;
              height: 18px;
              line-height: 18px;
              padding: 0 5px;
              text-align: center;
              white-space: nowrap;
              border: 1px solid #FFF;   
            }
          }
          &.is-active {
 
            .app-name {
              background-color: #d5eded; // #F5DADD;
              border-color: #d5eded; // #F5DADD;
              span {
                text-transform: uppercase;
                .set-font(@family: 'os-semibold', @size: 13px, @color: #5d5d5d);
              }
            }
            .barra {
              background-color: #007E85; //@rossoRiva;
              border: 1px solid #007E85; //@rossoRiva;
            }
          }
          &:last-child {
            padding: 0px;
          }
          &:nth-child(2) {
            padding: 0px;
          }
        }
      }
    }
    .box-documenti {
      padding: 0px;
    }
  }
  .document-menu-2 {
    height: 60px;
    padding-top: 10px;
    margin-left: 10px;
    .link {
      display: block;
      float: left;
      width: 150px;
      text-align: center;
      height: 40px;
      margin-top: 10px;
      //line-height: 40px;
      background-color: #dedede;
      .el-badge {
        .el-badge__content{
          top: 20px;
          right: 32px;
        }
      }
      .app-name {
        background-color: #dedede;
        display: block;
        float: left;
        width: 150px;
        text-align: center;
        height: 40px;
        border-right: 2px solid #fff;
        border-top-right-radius: 40px 40px;
        .set-font(@family: 'os-semibold', @size: 13px, @color: @grayTesto);
        text-transform: uppercase;
        span {
          width: 115px;
          display: block;
          height: 40px;
          cursor: pointer;
        }
      }
      &.first {
        width: 170px;
        .app-name {
          width: 170px;
        }
      }
      &.last {
        background-color: transparent;
      }
      &.select {
        //height: 50px;
        //margin-top: 0;
        .app-name {
           //height: 50px;
           background-color: #c852b8;
           .set-font(@family: 'os-semibold', @size: 13px, @color: #fff);
        }
      }
      &.selectPrev {
         background-color: #c852b8;
      }
    }
  }
  /*
  .document-menu {
    padding-top: 10px;
    .titolo-app {
      padding-left: 5px;
      .set-font(@size: 15px; @color: @greenRiva);
      letter-spacing: 2px;
      overflow: hidden;
      height: 50px;
      line-height: 50px;
      font-weight: 700;
    }
    .link-select {
      //text-transform: uppercase;
      //letter-spacing: 3px !important;
      letter-spacing: 3px;
      text-transform: uppercase;
      border: 1px solid #C9C9C9;
      background-color: @oroRiva;
      font-family: "os-regular";
      //font-weight: normal !important;
      font-size: 14px;
      // float: right !important;
      color: @white;
      border-radius: 0px;
      -webkit-box-shadow: 3px 3px 4px @grayLight;
      box-shadow: 3px 3px 4px @grayLight;
      margin: 00px 10px 20px 10px;
      padding: 8px 12px;
      height: 40px;
      text-align: right;
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .link {
      //text-transform: uppercase;
      //letter-spacing: 3px !important;
      border: 1px solid #C9C9C9;
      background-color: @white;
      font-family: "os-regular";
      //font-weight: normal !important;
      font-size: 14px;
      // float: right !important;
      color: #707070;
      border-radius: 0px;
      -webkit-box-shadow: 3px 3px 4px @grayLight;
      box-shadow: 3px 3px 4px @grayLight;
      margin: 0px 10px 20px 10px;
      padding: 8px 12px;
      height: 40px;
      text-align: right;
      cursor: pointer;
    }
  }
  */
  .index-documenti {
    height: 100%;
    padding: 0px 10px 10px 10px;
    .titolo-app {
      padding-left: 5px;
      .set-font(@size: 15px; @color: @greenRiva);
      text-transform: uppercase;
      letter-spacing: 2px;
      overflow: hidden;
      height: 50px;
      line-height: 50px;
      .titolo-bold {
        font-weight: 700;
      }
    }
    .icone {
      padding-top: 10px;
      .icona {
        text-align: center;
        .icona-menu {
          padding-left: 0px;
          padding-right: 3px;
          text-align: right;
          display: inline-block;
          vertical-align: middle;
        }
        .label-menu {
          .set-font(@size: 12px; @weight: bold);
          text-align: center;
          display: inline-block;
          vertical-align: middle;
        }
      }
      .icona:hover {
        cursor: pointer;
      }
    }
    /*.contenitore {
      -webkit-box-shadow: 0 0 10px 2px #cecece;
      -moz-box-shadow: 0 0 10px 2px #cecece;
      box-shadow: 0 0 10px 2px #cecece;
      background-color: #ffffff;
      margin: auto;
      overflow-x: hidden;

      text-align: center;
      .cat {
        cursor: pointer;
        img {
          cursor: pointer;
          margin-top: 10px;
          height: 65px;
          margin-bottom: 10px;
        }
        .didascaliaIcone {
          // width: 60%;
          word-wrap: break-word;
          margin-right: auto;
          margin-left: auto;
          color: #58585a;
          min-height: 50px;
          font-family: 'Roboto-Bold' !important;
          border-top: 1px solid orange;
          letter-spacing: 1px;
          text-transform: uppercase;
          cursor: pointer;
          padding-top: 10px;
        }
        .docToRead {
          position: relative;
          top: -5px;
          right: 0px;
          padding: 2px 6px;
          color: white;
        }
      }
    }
    .menu-carousel {
      height: 370px;
      border-bottom: 1px solid #c0c4cc;
      margin-left: 10px;
      margin-right: 10px;
      .el-carousel__container {
        height: 330px;
      }
    }*/
    .box-left {
      border-right: 1px solid @greyLine;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Documenti/IndexDocumenti.vue